/**
 * Canonical entitlement helpers — single source: user.entitlements from /auth/me.
 * Do not infer access from plan name strings or localStorage.
 */

export function getEntitlements(user) {
  const ents = user?.entitlements;
  if (!ents || typeof ents !== "object" || Array.isArray(ents)) return null;
  return ents;
}

/** True when /auth/me has supplied a complete entitlements object (limits present). */
export function entitlementsReady(user) {
  const ents = getEntitlements(user);
  return Boolean(ents && Object.prototype.hasOwnProperty.call(ents, "max_variants"));
}

export function getMaxVariants(ents) {
  if (!ents || !Object.prototype.hasOwnProperty.call(ents, "max_variants")) return null;
  const n = Number(ents.max_variants);
  // JS Number(null)===0 — treat null/NaN as unknown, not a hard 0-limit.
  if (ents.max_variants === null || ents.max_variants === undefined || !Number.isFinite(n)) {
    return null;
  }
  return n;
}

export function canCreateVariant(ents, currentCount) {
  const max = getMaxVariants(ents);
  if (max === null) return false;
  if (max < 0) return true; // unlimited
  return currentCount < max;
}

export function hasFeature(ents, key) {
  if (!ents) return false;
  return !!ents[key];
}

export function getMaxLinks(ents) {
  if (!ents || !Object.prototype.hasOwnProperty.call(ents, "max_links")) return null;
  const n = Number(ents.max_links);
  if (ents.max_links === null || ents.max_links === undefined || !Number.isFinite(n)) return null;
  return n;
}

export function canAddLink(ents, currentCount) {
  const max = getMaxLinks(ents);
  if (max === null) return false;
  if (max < 0) return true;
  return currentCount < max;
}
